import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../../types'
import {
  OpenPanelMainContentRightRowData
} from '../../../open-panel/open-panel-containers/open-panel-main-content-right/open-panel-main-content-right-row/open-panel-main-content-right-row.component.converter'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class AccordionMainContentRightRowConverter extends CmsConverterService<AccordionMainContentRightRowData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      text: formData.st_accordion_row_headline ?? defaultTextInput,
      fullwidth: formData.st_full_width?.value ?? false,
      rows: formData.st_rows ?? defaultFSCatalog
    }
  }
}

export const ACCORDION_MAIN_CONTENT_RIGHT_ROW_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, AccordionMainContentRightRowData>>('AccordionMainContentRightRowConverter')

export interface AccordionMainContentRightRowData extends ConvertedComponentData {
  rows: FsCatalog<OpenPanelMainContentRightRowData>;
  text: TextInput;
  fullwidth: boolean;
}
